export default __webpack_public_path__ + "static/yoga-teacher-training-f3b9d88f3e3210ca24cb2e5ea668f1c7.png";